// You can write more code here

import { uiAssetsPath } from '@/app/constants';
import {
  PhaserAudioManager,
  RANDOM_SOUND_OPTIONS,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import { HOVER_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';

/* START OF COMPILED CODE */

export default class HUDButton extends Phaser.GameObjects.Image {
  constructor(
    scene: Phaser.Scene,
    x?: number,
    y?: number,
    texture?: string,
    frame?: number | string,
  ) {
    super(scene, x ?? 0, y ?? 0, texture || 'hud-icons', frame ?? 245);

    this.scaleX = 2;
    this.scaleY = 2;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    this.defaultScaleX = this.scaleX;
    this.defaultScaleY = this.scaleY;
    /* END-USER-CTR-CODE */
  }

  public defaultIcon: string = '0';
  public hoverIcon: string = '0';
  public pressButton: string = '0';
  public useAlternateTextures: boolean = false;

  /* START-USER-CODE */
  defaultScaleX: number;
  defaultScaleY: number;
  hoverScaleFactor: number = 1.1;
  onSubmitted?: () => void;
  public hoverSFX: string = 'hover-click';
  public submitSFX: string = 'submit-click';

  awake() {
    const { defaultScaleX, defaultScaleY, hoverScaleFactor } = this;
    this.setInteractive({ cursor: `${HOVER_CURSOR_PATH}, auto` });
    this.on('pointerover', () => {
      if (this.useAlternateTextures) {
        this.setTexture(this.texture.key, this.hoverIcon);
      }
      this.setScale(
        defaultScaleX * hoverScaleFactor,
        defaultScaleY * hoverScaleFactor,
      );
      PhaserAudioManager.playSFX(
        this.scene,
        this.hoverSFX,
        RANDOM_SOUND_OPTIONS,
      );
    });
    this.on('pointerout', () => {
      if (this.useAlternateTextures) {
        this.setTexture(this.texture.key, this.defaultIcon);
      }
      this.setScale(defaultScaleX, defaultScaleY);
      this.scene.input.setDefaultCursor(
        `url(${uiAssetsPath}cursors/glove_pointer_64_64.png), auto`,
      );
    });
    this.on('pointerdown', () => {
      if (this.useAlternateTextures) {
        this.setTexture(this.texture.key, this.pressButton);
      }
      this.setScale(
        defaultScaleX * hoverScaleFactor,
        defaultScaleY * hoverScaleFactor,
      );
      PhaserAudioManager.playSFX(
        this.scene,
        this.submitSFX,
        RANDOM_SOUND_OPTIONS,
      );
    });
    this.on('pointerup', () => {
      if (this.useAlternateTextures) {
        this.setTexture(this.texture.key, this.hoverIcon);
      }
      this.setScale(
        defaultScaleX * hoverScaleFactor,
        defaultScaleY * hoverScaleFactor,
      );
    });
    //this.controller.setSubmissionCallback(this.onSubmitted);
  }

  setSubmissionCallback(callback: () => void) {
    this.onSubmitted = callback;
    this.off('pointerdown', this.onSubmitted);
    this.on('pointerdown', this.onSubmitted);
  }

  setInteractionEnabled(enabled: boolean) {
    if (enabled) {
      this.setInteractive({ cursor: `${HOVER_CURSOR_PATH}, auto` });
      this.alpha = 1;
    } else {
      this.disableInteractive();
      this.alpha = 0.5;
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
